import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ctaHref, ctaIsExternal } from '../config/site';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const href = ctaHref();
  const external = ctaIsExternal();
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const offer = document.getElementById('oferta');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const offerTop = offer ? offer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      const offerBottom = offer ? offer.getBoundingClientRect().bottom : Number.NEGATIVE_INFINITY;
      const pastHero = heroBottom < -200;
      const insideOffer = offerTop < window.innerHeight * 0.9 && offerBottom > 0;
      setVisible(pastHero && !insideOffer);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-112" data-mp="2z4bo57ges7q4">
      {visible && <motion.a href={href} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} initial={{
      y: '100%'
    }} animate={{
      y: 0,
      boxShadow: ['0 -4px 14px -6px rgba(14,122,70,0.5)', '0 -8px 26px -6px rgba(14,122,70,0.85)', '0 -4px 14px -6px rgba(14,122,70,0.5)']
    }} exit={{
      y: '100%'
    }} transition={{
      y: {
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      },
      boxShadow: {
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }
    }} className="fixed inset-x-0 bottom-0 z-30 flex h-[58px] items-center justify-center bg-cta px-4 text-center text-sm font-extrabold uppercase tracking-tight text-white md:hidden" data-id="element-113" data-mp="332hpu12e3x46">
          Uzyskaj dostęp — 17 USD
        </motion.a>}
    </AnimatePresence>;
}